
import * as Actions from './actions.js'

const initialState = {
  open: false,
  patientFolder: true
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.NAV_BAR_OPEN:
      return {
        ...initialState,
        open: true,
        patientFolder: false
      }
    case Actions.NAV_BAR_CLOSE:
      return {
        ...state,
        open: false,
        patientFolder: false
      }
    case Actions.PATIENT_FOLDER_CLOSE:
      return {
        ...state,
        open: false,
        patientFolder: true
      }
    default:
      return state
  }
}
